import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Organization = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Organization" {...props}>
    <path d="M15 1C16.6569 1 18 2.34315 18 4V5H19C20.6569 5 22 6.34315 22 8V21C22.5523 21 23 21.4477 23 22C23 22.5523 22.5523 23 22 23H2C1.44772 23 1 22.5523 1 22C1 21.4477 1.44772 21 2 21V4C2 2.34315 3.34315 1 5 1H15ZM5 3C4.44772 3 4 3.44772 4 4V21H7V19C7 17.8954 7.89543 17 9 17H11C12.1046 17 13 17.8954 13 19V21H16V4C16 3.44772 15.5523 3 15 3H5ZM9 21H11V19H9V21ZM18 21H20V8C20 7.44772 19.5523 7 19 7H18V21ZM14 13C14.5523 13 15 13.4477 15 14C15 14.5523 14.5523 15 14 15H6C5.44772 15 5 14.5523 5 14C5 13.4477 5.44772 13 6 13H14ZM14 9C14.5523 9 15 9.44772 15 10C15 10.5523 14.5523 11 14 11H6C5.44772 11 5 10.5523 5 10C5 9.44772 5.44772 9 6 9H14ZM14 5C14.5523 5 15 5.44772 15 6C15 6.55228 14.5523 7 14 7H6C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5H14Z" fill="#000" />
  </StyledIcon>
));

Organization.displayName = 'Organization';

export { Organization };
